import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import DEFINES from '@/defines'

const sentry=() => {
    //record errors for production app only
    if(DEFINES.NODE_ENV === 'production'){
        return Sentry.init({
            dsn: process.env.VUE_APP_SENTRY_DSN,
            integrations: [new Integrations.Vue({Vue, attachProps: true})],
        });
    }
}

export default sentry();
